/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SaveOidcProviderMutationVariables = Types.Exact<{
  input: Types.SsoProviderOidcUpsertInput;
}>;


export type SaveOidcProviderMutation = { __typename: 'Mutation', ssoProviderOidcUpsert: { __typename: 'OidcProvider', displayName?: string | null, validationStatus?: Types.SsoValidationStatus | null, strategy: Types.SsoProviderStrategy, options: { __typename: 'OidcOptions', clientId?: string | null, issuer?: string | null } } };

export type PublishOidcMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type PublishOidcMutation = { __typename: 'Mutation', ssoProviderOidcPublish: { __typename: 'Sso', id: string, domain: string, verificationStatus: Types.DomainVerificationStatus, provider?: { __typename: 'OidcProvider', displayName?: string | null, validationStatus?: Types.SsoValidationStatus | null, strategy: Types.SsoProviderStrategy } | { __typename: 'SamlProvider' } | null } };


export const SaveOidcProviderDocument = gql`
    mutation SaveOidcProvider($input: SsoProviderOidcUpsertInput!) {
  ssoProviderOidcUpsert(input: $input) {
    displayName
    validationStatus
    strategy
    options {
      clientId
      issuer
    }
  }
}
    `;
export type SaveOidcProviderMutationFn = ApolloReactCommon.MutationFunction<SaveOidcProviderMutation, SaveOidcProviderMutationVariables>;

/**
 * __useSaveOidcProviderMutation__
 *
 * To run a mutation, you first call `useSaveOidcProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOidcProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOidcProviderMutation, { data, loading, error }] = useSaveOidcProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOidcProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveOidcProviderMutation, SaveOidcProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveOidcProviderMutation, SaveOidcProviderMutationVariables>(SaveOidcProviderDocument, options);
      }
export type SaveOidcProviderMutationHookResult = ReturnType<typeof useSaveOidcProviderMutation>;
export type SaveOidcProviderMutationResult = ApolloReactCommon.MutationResult<SaveOidcProviderMutation>;
export type SaveOidcProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveOidcProviderMutation, SaveOidcProviderMutationVariables>;
export const PublishOidcDocument = gql`
    mutation PublishOidc($id: ID!) {
  ssoProviderOidcPublish(input: {id: $id}) {
    id
    domain
    verificationStatus
    provider {
      ... on OidcProvider {
        displayName
        validationStatus
        strategy
      }
    }
  }
}
    `;
export type PublishOidcMutationFn = ApolloReactCommon.MutationFunction<PublishOidcMutation, PublishOidcMutationVariables>;

/**
 * __usePublishOidcMutation__
 *
 * To run a mutation, you first call `usePublishOidcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOidcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOidcMutation, { data, loading, error }] = usePublishOidcMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishOidcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishOidcMutation, PublishOidcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishOidcMutation, PublishOidcMutationVariables>(PublishOidcDocument, options);
      }
export type PublishOidcMutationHookResult = ReturnType<typeof usePublishOidcMutation>;
export type PublishOidcMutationResult = ApolloReactCommon.MutationResult<PublishOidcMutation>;
export type PublishOidcMutationOptions = ApolloReactCommon.BaseMutationOptions<PublishOidcMutation, PublishOidcMutationVariables>;